import React from 'react';
import Footer from '../../components/Footer';
import NewsBody from './NewsBody';

const News = () => {
    return (
        <section>
            <NewsBody />
            <Footer />
        </section>
    );
};

export default News;